import { getWindow } from '@jira/ssr__browser-globals/src/getWindow.tsx';

export const getBundlerVersion = (): any => getWindow()?.BUNDLER_VERSION; // oxlint-disable-line @typescript-eslint/no-explicit-any
